export const CLIENT_AS_PUBLISHER = "CLIENT_AS_PUBLISHER";
export const CLIENT_AS_ADVERTISER = "CLIENT_AS_ADVERTISER";
export const EMPLOYEE_AS_SELF = "EMPLOYEE_AS_SELF";
export const EMPLOYEE_AS_ADVERTISER = "EMPLOYEE_AS_ADVERTISER";
export const EMPLOYEE_AS_PUBLISHER = "EMPLOYEE_AS_PUBLISHER";
export const CLIENT_AS_SELF = "CLIENT_AS_SELF";
